export default __webpack_public_path__ + "static/media/person-gray-carve.f567c872.svg";